import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, MessageCircle, X } from 'lucide-react';
import { useSiteContent } from '../context/SiteContentContext';

const FloatingContact = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { siteContent } = useSiteContent() || {};

  const rawPhone = siteContent?.contact?.phone || '+919649611111';
  const rawWhatsapp = siteContent?.contact?.whatsapp || rawPhone;
  const phoneNumber = rawPhone.replace(/\s/g, '');
  const whatsappNumber = rawWhatsapp.replace(/\s/g, '').replace('+', '');
  const whatsappMessage = encodeURIComponent('Hi! I would like to inquire about booking at Rudragarh Resort.');

  return (
    <div className="fixed bottom-24 right-6 z-40" data-testid="floating-contact">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.8 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.8 }}
            className="absolute bottom-16 right-0 mb-2 space-y-2"
          >
            {/* WhatsApp */}
            <a
              href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 px-4 py-3 bg-green-600 hover:bg-green-700 text-white rounded-full shadow-lg transition-all"
              data-testid="whatsapp-btn"
            >
              <MessageCircle size={20} />
              <span className="text-sm font-medium whitespace-nowrap">WhatsApp</span>
            </a>

            {/* Call */}
            <a
              href={`tel:${phoneNumber}`}
              className="flex items-center gap-3 px-4 py-3 bg-gold-500 hover:bg-gold-600 text-black rounded-full shadow-lg transition-all"
              data-testid="call-btn"
            >
              <Phone size={20} />
              <span className="text-sm font-medium whitespace-nowrap">Call Us</span>
            </a>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Main Toggle Button */}
      <motion.button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all ${
          isOpen ? 'bg-void-subtle border border-gold-500/50' : 'bg-gold-500'
        }`}
        whileTap={{ scale: 0.95 }}
        data-testid="contact-toggle"
      >
        {isOpen ? (
          <X size={24} className="text-gold-500" />
        ) : (
          <MessageCircle size={24} className="text-black" />
        )}
      </motion.button>
    </div>
  );
};

export default FloatingContact;
